<template>
  <router-view />
</template>
<script>
export default {
  name: 'Peyman',
};
</script>
